<template>
  <div class="callee-editors">
    <div v-for="call in caseConf.dialogue.calls" v-show="activeId === call.id" :key="call.id" class="call-container" :data-testid="`${call.callee.en}-dialogue-editor-container`">
      <div class="old-globals two-column-grid">
        <label for="voice">Voice</label>
        <voice-selector
          :voice-key="call.calleeVoiceId"
          :voices="voices"
          :readonly="readonly"
          :showLabel="false"
          aria-label="Callee Voice Selector"
          data-testid="voice-selector"
          :disabled-voice-keys="disabledForCallee(call.id).map(info => info.voiceKey)"
          @update="voiceKey => updateCallVoice(call.id, voiceKey)"
        />
      </div>
      <dialogue-editor
        v-show="activeId === call.id && activeTab === DialogueType.Q_AND_A"
        id="call-questions"
        :key="`${call.id}_QANDA`"
        class="new-globals"
        data-testid="questions-and-answers-container"
        :settings="callSettings"
        :items="call.items || []"
        :readonly="readonly"
        :errors="errors"
        :warnings="warnings"
        :title-prefix="call.callee.en + ': '"
        @update="(items) => updateCallItems(call.id, items)"
        @playAudio="(item) => playAnswerText(item, call.calleeVoiceId)"
      />
      <dialogue-editor
        v-show="activeId === call.id && activeTab === DialogueType.UNSOLICITED"
        id="call-unsolicited"
        :key="`${call.id}_UNSOLICITED`"
        class="new-globals"
        data-testid="unsolicited-container"
        :settings="callUnsolicitedSettings"
        :items="call.unsolicited || []"
        :readonly="readonly"
        :errors="errors"
        :warnings="warnings"
        :title-prefix="call.callee.en + ': '"
        @update="(items) => updateCallUnsolicited(call.id, items)"
        @playAudio="(item) => playAnswerText(item, call.calleeVoiceId)"
      />
    </div>
  </div>
</template>

<script>
import DialogueEditor from './DialogueEditor.vue';
import DialogueType from './DialogueType';
import VoiceSelector from '../common/VoiceSelector.vue';

export default {
  name: 'callee-editors',
  components: {
    DialogueEditor,
    VoiceSelector,
  },
  props: {
    activeId: {
      type: String,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
    caseConf: {
      type: Object,
      required: true,
    },
    voices: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
    usedInfo: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      callSettings: {
        onText: 'On-at-Start Questions',
        offText: 'Off-at-Start Questions',
        questionLabel: 'Dialogue',
        answerLabel: 'Response',
        newQuestionLabel: 'Add a question',
        newAnswerLabel: 'Add an answer',
      },
      callUnsolicitedSettings: {
        type: DialogueType.UNSOLICITED,
        offText: 'Unsolicited',
        offSubtitle: 'Unsolicited needs to be triggered by an action or timer in Case Logic',
        onDisabled: true,
        isQuestionDisabled: true,
        answerLabel: 'Callee Unsolicited',
        newAnswerLabel: 'Add a question or statement to say'
      },
      DialogueType,
    };
  },
  methods: {
    disabledForCallee(callId) {
      return this.usedInfo.filter(info => info.key !== callId);
    },
    updateCallVoice(callId, voiceKey) {
      this.$emit('update', {
        dialogue: {
          calls: (this.caseConf.dialogue.calls || []).map((call) =>
            call.id === callId
              ? {
                  ...call,
                  calleeVoiceId: voiceKey,
                }
              : call
          ),
        },
      });
    },
    updateCallItems(callId, items) {
      this.$emit('update', {
        dialogue: {
          calls: (this.caseConf.dialogue.calls || []).map((call) =>
            call.id === callId
              ? {
                  ...call,
                  items,
                }
              : call
          ),
        },
      });
    },
    updateCallUnsolicited(callId, unsolicited) {
      this.$emit('update', {
        dialogue: {
          calls: (this.caseConf.dialogue.calls || []).map((call) =>
            call.id === callId
              ? {
                  ...call,
                  unsolicited,
                }
              : call
          ),
        },
      });
    },
    playAnswerText(question, withVoiceId) {
      this.$emit('playAnswerText', question, withVoiceId);
    },
  },
}
</script>

<style scoped>
.callee-editors {
  height: 100%;
  padding-top: 12px;
}

.call-container {
  height: 100%;
}

.two-column-grid {
  width: 480px;
  margin-bottom: 1rem;
}
</style>